import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../axios/axiosInstance';

export interface Appointment {
    payment_status: number; 
    appointment_status: number; 
    id: number; 
    appointment_type_id: number; 
    doctorTimeslot: {
        time_sloat: string; 
        doctorDate: {
            date: string; 
            doctor: {
                name: string; 
                img: string; 
            };
        };
    };
    onlineMeetings: OnlineMeeting[];
    paymentStatement: PaymentStatement | null; 
}
interface OnlineMeeting {
    link:string;
}

interface PaymentStatement {
    type: string;
    cash_payment: number; 
    card_payment: number;
    discount: number; 
    status: number;
}
interface PaymentLink {
    ipg_transaction_id: string;
    amount: {
        gross_amount: number;
        discount: number;
        handling_fee: number;
        net_amount: number;
        currency: string;
    };
    gateway: {
        redirect_url: string;
    };
}

interface AppointmentState {
    appointments: Appointment[];
    payment: PaymentLink | null;
    loading: boolean;
    error: string | null;
    paymentLoading: boolean;
    paymentError: string | null;
}

const initialState: AppointmentState = {
    appointments: [],
    payment: null,
    loading: false,
    error: null,
    paymentLoading: false,
    paymentError: null,
};

// Async thunk for fetching active blog categories
export const fetchAppointments = createAsyncThunk<any, { id: number }>(
    'patientAppointment/fetchAppointments',
    async ({ id }, { rejectWithValue }) => {
        try {
            // const baseUrl = process.env.API_URL;
            const response = await axiosInstance.get(
                `/appointment/get-by-patient/${id}`
            );
            return response.data.appointments;
        } catch (error: any) {

            return rejectWithValue(
                error.response?.data?.message || 'Failed to Place Appointment'
            );
        }
    }
);

export const saveAppointmentDB = createAsyncThunk<any, { doctor_timesloat_id: number | undefined, illness_id: number|undefined, patient_profile_id: number, is_gift: number, is_voucher: number, appointment_charge_id: number, is_feature: number, card_payment: string, discount: number,email: string | undefined }>(
    'patientAppointment/saveAppointment',
    async ({ doctor_timesloat_id, illness_id, patient_profile_id, is_gift, is_voucher, appointment_charge_id, is_feature, card_payment, discount,email }, { rejectWithValue }) => {
        try {
            // const baseUrl = process.env.API_URL;
            const payload = {
                doctor_timesloat_id,
                illness_id,
                patient_profile_id,
                is_gift,
                is_voucher,
                appointment_charge_id,
                is_feature,
                card_payment,
                discount,
                email,
            };
            const response = await axiosInstance.post('/appointment/create-web', payload);
            return response.data.paymentLink;
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message || 'Failed to Book Appointment'
            );
        }
    }
);

const AppointmentSlice = createSlice({
    name: 'Appointment',
    initialState,
    reducers: {
        clearPaymentError: (state) => {
            state.paymentError = null;
            state.paymentLoading = false;
        },
        clearPayment: (state) => {
            state.paymentLoading = false;
            state.payment = null;
            state.paymentError = null;
        },
    }, extraReducers: (builder) => {
        builder
            .addCase(fetchAppointments.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAppointments.fulfilled, (state, action) => {
                state.loading = false;
                state.appointments = action.payload;
            })
            .addCase(fetchAppointments.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            .addCase(saveAppointmentDB.pending, (state) => {
                state.paymentLoading = true;
                state.paymentError = null;
            })
            .addCase(saveAppointmentDB.fulfilled, (state, action) => {
                state.paymentLoading = false;
                state.payment = action.payload;
            })
            .addCase(saveAppointmentDB.rejected, (state, action) => {
                state.paymentLoading = false;
                state.paymentError = action.payload as string;
            });
    },
});
export const { clearPaymentError,clearPayment } = AppointmentSlice.actions;
export default AppointmentSlice.reducer;
